// src/components/ErrorContext.js
import React, { createContext, useState, useContext, useCallback } from 'react';

const ErrorContext = createContext(null);

export const useError = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
  // The error object will now hold the buttons array
  const [error, setError] = useState(null); // { title, message, buttons }

  // Update showError to accept a third argument
  const showError = useCallback((title, message, buttons = null) => { // <-- ADD ", buttons = null"
    setError({ title, message, buttons }); // <-- ADD "buttons" TO THE OBJECT
  }, []);

  const hideError = useCallback(() => {
    setError(null);
  }, []);

  const value = { error, showError, hideError };

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};